












import Vue from 'vue';
import axios from '@/utils/axios';
export default Vue.extend({
    props: {
        url: {
            type: String,
            required: true,
        },
        perPage: {
            type: Number,
            default: 50,
        },
        page: {
            type: Number,
            default: 0,
        },
        search: {
            type: String,
            default: '',
        },
        sysFwe: {
            type: Object,
            default: null,
        },
    },
    data: function() {
        return {
            initialFetchDone: false,
            items: [] as unknown[],
            currentPage: 0,
            total: 0,
            isLoading: false,
        };
    },
    computed: {
        paginatedUrl(): string {
            let paginatedUrl = `${this.url}?limit=${this.perPage}&offset=${this.items.length}`;
            if (this.search !== '') {
                paginatedUrl += `&query=${this.search}`;
            }
            if (this.sysFwe) {
                paginatedUrl += `&sys_fwe=${JSON.stringify(this.sysFwe)}`;
            }
            return paginatedUrl;
        },
    },
    watch: {
        async search() {
            this.currentPage = 0;
            this.total = 0;
            this.items = [];
            this.items = await this.fetch();
        },
        async url() {
            this.currentPage = this.page;
            this.total = 0;
            this.items = [];
            this.items = await this.fetch();
        },
        async sysFwe() {
            this.currentPage = 0;
            this.total = 0;
            this.items = [];
            this.items = await this.fetch();
        },
    },
    methods: {
        async initialFetch() {
            if (!this.initialFetchDone) {
                this.items = await this.fetch();
            }
        },
        hasNextPage(): boolean {
            if (this.isLoading) {
                return false;
            }
            return this.total ? this.items.length < this.total : false;
        },
        async fetchNextPage() {
            this.currentPage++;
            const items = await this.fetch();
            this.items = this.items.concat(items);
        },
        async fetch(): Promise<unknown[]> {
            this.isLoading = true;
            try {
                const result = await axios.get(this.paginatedUrl);
                this.isLoading = false;
                this.initialFetchDone = true;

                // TODO: implement refine search
                // For now we remove it
                const refine = result.data.data.items.some((i: any) => i.value === -101);
                if (refine) {
                    this.total = result.data.total - 1;
                    return result.data.data.items.filter((i: any) => i.value !== -101);
                } else {
                    this.total = result.data.total;
                    return result.data.data.items;
                }
            } catch (e) {
                this.$emit('error', e);
                this.isLoading = false;
                this.total = 0;
                return [];
            }
        },
    },
});
